export const symmetricDifference = (array1, array2) => {
    return [
        ...array1.filter((item) => !array2.includes(item)),
        ...array2.filter((item) => !array1.includes(item)),
    ];
};

export const symmetricDifferenceByID = (array1, array2) => {
    return [
        ...array1.filter((item) => !array2.find((i) => i.id === item.id)),
        ...array2.filter((item) => !array1.find((i) => i.id === item.id)),
    ];
};